import * as actionTypes from "../actions/actionTypes";

import { updateObject } from "../utility";

const initialState ={
    productlist:[],
  }

  const fetch_all_productListSuccess = (state, action) => {
   // //console.log(action,"noooooooo")
    return updateObject(state, {
        productlist: action.productlist,
    });
  };

  const reducer = (state = initialState, action) => {
    //console.log()
    switch (action.type) {
      case actionTypes.FETCH_ALL_PRODUCTS:
        return fetch_all_productListSuccess(state, action);
      default:
        return state;
    }
  };

  export default reducer;